export const ORGANIZATION_LAYOUT_WIDTH = 1134;